/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  addnewUserData : null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddNewUserAction.REQUEST_ADDNEWUSER:
      return {
        ...state,
    };
    case actions.AddNewUserAction.ADDNEWUSER_RECEIVED:
          return{
      ...state,
      addnewUserData : action.data, // Store full Status object with StatusCode and StatusDesc

    };

    default:
      return state;
  }
};

export default reducer;
